import { render } from "./ModalPersonalize.vue?vue&type=template&id=aebb848e&scoped=true"
import script from "./ModalPersonalize.vue?vue&type=script&lang=js"
export * from "./ModalPersonalize.vue?vue&type=script&lang=js"

import "./ModalPersonalize.vue?vue&type=style&index=0&id=aebb848e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebb848e"]])

export default __exports__